import angular from 'angular';

import RenderComponentDirective from './render-component.directive';

export default angular.module('dbm.dashboard.shared.render-component', [])
.directive('renderComponent', ['$compile',$compile => {
    'ngInject';
    return new RenderComponentDirective($compile);
}])
.name;



// WEBPACK FOOTER //
// ./src/app/authorized/newDashBoard/shared/render-component/index.js